module.exports = __webpack_public_path__ + "img/product_2.944cd42.webp";